var $d8a227e68ad46b5f$exports = {};
$d8a227e68ad46b5f$exports = {
    "(optional)": `(voliteln\u{11B})`,
    "(required)": `(po\u{17E}adov\xe1no)`
};


export {$d8a227e68ad46b5f$exports as default};
//# sourceMappingURL=cs-CZ.mjs.map
